/**
 * Welcher Weg zur Datenbank beim Speichern eines Streckenpreises (H1.6).
 *
 * Vorher gab es einen Weg: `upsert` bzw. `delete` nach Vorlage, ohne Stand.
 * Damit überschrieb das Büro still einen Preis, den eine Kollegin eine Minute
 * vorher eingetragen hatte, oder räumte ihn weg, ohne ihn je gesehen zu
 * haben. Jetzt hängt der Weg an zwei Fragen: Stand beim Öffnen ein Preis da
 * (dann gibt es einen gelesenen Stand), und soll danach einer dastehen?
 *
 * Die Entscheidung steht für sich in dieser Datei, ohne Supabase, damit
 * `npm run logik` sie ohne Browser und ohne Server prüfen kann. Vier Fälle
 * in einer Zeile Test sind billiger als vier Seiten im Durchklicken — und
 * deshalb werden sie auch alle hingeschrieben.
 */

export type Preisvorgang = 'anlegen' | 'aendern' | 'entfernen' | 'nichts';

export type Preiswerte = {
  preisart: string | null;
  preis_vk: number | null;
  mengeneinheit: string | null;
};

/**
 * @param gelesenerStand `geaendert_am` des Preises, den das Formular beim
 *   Öffnen gesehen hat — `null`, wenn es keinen gab.
 */
export function preisVorgang(
  gelesenerStand: string | null,
  werte: Preiswerte,
): Preisvorgang {
  // Ohne Art oder ohne Betrag ist es kein Preis. 0 ist ein Betrag.
  const sollPreisHaben = werte.preisart !== null && werte.preis_vk !== null;

  if (gelesenerStand === null) {
    // Insert, kein Upsert: Hat jemand inzwischen einen Preis angelegt, soll
    // der Primärschlüssel das melden, statt dass unserer ihn ersetzt.
    // Und „entfernen" ohne gelesenen Preis heißt: Es gab nichts zu entfernen.
    // Ein inzwischen fremd angelegter Preis bleibt stehen.
    return sollPreisHaben ? 'anlegen' : 'nichts';
  }
  return sollPreisHaben ? 'aendern' : 'entfernen';
}
